<template>
    <div class="a" v-loading="loading">
        <div style="padding-top: 596px;padding-left: 20px; padding-right: 20px;box-sizing: border-box;">
            <div class="c">
                <div style="padding-top: 67px;display: flex;justify-content: center;align-items: center;">
                    <img src="../../assets/13.png" alt="" rcset="">
                </div>
                <div v-if="list.length" style="min-height: 1259px;">
                    <div class=""
                        style="display: grid;grid-template-columns: repeat(4, minmax(0, 1fr));column-gap: 24px;row-gap: 24px;padding: 44px;">
                        <div class="" v-for="item in list" :key="item.id" @click="likeSwitch(item)">
                            <div style="width: 100%;height: 242px;border-radius: 8px;">
                                <img v-if="item.resource"
                                    :src="item.resource.indexOf('.mp4') == -1 ? item.resource : item.videoUrl"
                                    style="width: 242px;height: 242px;border-radius: 8px;" alt="" srcset="">
                            </div>
                            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 12px;">
                                <div style="color: #333333;font-size: 16px;font-weight: 700;"><span>{{ item.title }}</span>
                                </div>
                                <!-- <div
                                    style="color: #C01A26;font-size: 14px;font-weight: 400;display: flex;align-items: center;cursor: pointer;width: 120px;text-align: right;">
                                    <span>查看简介</span><el-icon style="padding-top: 3px;">
                                        <ArrowRight />
                                    </el-icon>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="list.length"
                    style="padding-bottom: 25px;padding-top: 0px; display: flex;justify-content: center;align-items: center;width: 100%;">
                    <el-pagination background :total="queryParams.total" class="cccccccc"
                        :current-page="queryParams.pageNum" @current-change="paginationChange"
                        :page-size="queryParams.pageSize" />
                </div>
                <el-empty v-if="!list.length" />
            </div>
        </div>

        <el-dialog v-model="isShowShare_" :lock-scroll="false" :show-close="true" @close=" getList()"
            :close-on-click-modal="false" title="查看简介" width="900">
            <div class="">
                <div v-if="items.resource.indexOf('.mp4') == -1"
                    style="display: flex;justify-content: center;object-fit: scale-down;">
                    <img :src="items.resource" style="width: 400px;height: 400px;" />
                </div>
                <div v-else style="display: flex;justify-content: center;object-fit: scale-down;">
                    <video :src="items.resource" style="width: 100%;border-radius: 12px;height: 400px;padding-bottom: 15px;"
                        controls></video>
                </div>
                <div style="display: flex;justify-content: flex-end;" v-if="likeSwitch_ == 1">
                    <div class="" v-if="items.likeFlag" @click="likeBtn"
                        style="padding: 8px 12px; background: #E4E8EC;border-radius: 8px;display: flex;align-items: center;min-height: 40px;height: auto;cursor: pointer;">
                        <img src="../../assets/14.png" alt="" srcset="">
                        <span style="color: #333333;font-size: 14px;">点赞</span>
                        <span style="color: #C01A26;font-size: 16px;margin-left: 8px;">{{ items.likeNum }}</span>
                    </div>
                    <div class="" v-else @click="likeBtn"
                        style="padding: 8px 12px; background: #E4E8EC;border-radius: 8px;display: flex;align-items: center;min-height: 40px;height: auto;cursor: pointer;">
                        <img src="../../assets/15.png" alt="" srcset="">
                        <span style="color: #333333;font-size: 14px;">点赞</span>
                        <span style="color: #C01A26;font-size: 16px;margin-left: 8px;">{{ items.likeNum }}</span>
                    </div>
                </div>
                <div class="" style="color: #000000;font-size: 15px;font-weight: 600;margin-top: 20px;">
                    <span>公司简介</span>
                </div>
                <div style="color: #000000;font-size: 14px;margin-top: 8px;font-weight: 400;">
                    <span>{{ items.content }}</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script setup>
import { ref } from "vue"
import { ElMessage } from "element-plus"
import { Axios } from "../../assets/js/ls_com_axios.js";
let params = new URLSearchParams(location.search);
const queryParams = ref({
    pageNum: 1,
    pageSize: 16,
    total: 0
});
const list = ref([]);
const items = ref({});
const isShowShare_ = ref(false);
const likeSwitch_ = ref(2);
const loading = ref(false);
const likeSwitch = (item) => {
    Axios("get", '/system/activity/' + params.get("id"), {}, false, (res) => {
        if (res.data.code == 200) {
            likeSwitch_.value = res.data.data.likeSwitch;
            items.value = item;
            isShowShare_.value = true;
        }
    }, () => {
        likeSwitch_.value = 2;
    });
}
const getList = () => {
    loading.value = true;
    Axios("post", `/system/activity/rankingList?activityId=${params.get("id")}&pageNum=${queryParams.value.pageNum}&pageSize=${queryParams.value.pageSize}`, {}, false, (res) => {
        if (res.data.code == 200) {
            queryParams.value.total = res.data.total;
            list.value = res.data.rows;
            loading.value = false;
        } else {
            loading.value = false;
            ElMessage.error(res.data.msg || "查询失败");
        }
    }, () => {
        loading.value = false;
        ElMessage.error(res.data.msg || "查询失败");
    });
}
getList()
const paginationChange = (num) => {
    queryParams.value.pageNum = num;
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
    getList()
}
import { useRoute, useRouter } from "vue-router";
import axios from "axios"
const router = useRouter();
const route = useRoute();
const likeBtn = async () => {
    if (localStorage.getItem("token") == null) {
        router.push({
            path: "/TgLogin",
            query: {
                url: location.href
            }
        });
        return
    }
    let res = await axios({
        url: `https://api.biaoshisx.com/system/activity/likeCompany?id=${items.value.id}`,
        method: "post",
        headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token") != null ? "Bearer " + localStorage.getItem("token") : "",
            "Access-Control-Allow-Origin": "*",
        }
    });
    if (res.data.code == 200) {
        items.value.likeFlag = !items.value.likeFlag;
        if (items.value.likeFlag) {
            items.value.likeNum = items.value.likeNum + 1;
        } else {
            items.value.likeNum = items.value.likeNum - 1;
        }
    } else {
        ElMessage.error(res.data.msg || '请求失败，请联系管理员');
    }
}
</script>
<style lang="less" scoped>
.a {
    width: 1200px !important;
    min-height: 2122px;
    height: auto;
    padding-bottom: 47px;
    margin: 68px auto 0 !important;
    background: url('../../assets/11.png') no-repeat;
    background-size: 100% 100%;
}

.c {
    width: 100% !important;
    min-height: 1486px;
    height: auto;
    background: url("../../assets//12.png") no-repeat;
    background-size: 100% 100%;
}
</style>
<style>
.cccccccc.el-pagination.is-background .btn-next.is-active,
.cccccccc.el-pagination.is-background .btn-prev.is-active,
.cccccccc.el-pagination.is-background .el-pager li.is-active {
    background-color: #FC4735 !important;
}

/* .el-pager li.is-active, */
.cccccccc .el-pager li:hover {
    color: #FC4735 !important;
}

.cccccccc .el-pager li.is-active:hover {
    color: #FFF !important;
}
</style>